import { EventStatus, EventPriority, EventSignal, EventBattery } from 'src/components/Trap/Elements';
import { EVENTS_DELETABLE } from 'src/components/Trap/utils';
import { formatFromISO } from 'src/utils/datefns';
import { Button } from 'react-bootstrap';
import classes from './TrapOverview.module.scss';

export const EventRow = ({ item, onActionClick = null }) => {
  return (
    <tr className="utl-show-hover-container">
      <td><EventPriority priority={item.event_priority} isCaught={item.is_caught} eventName={item.event_name} /></td>
      <td>{formatFromISO(item.time, 'HH:mm')}</td>
      <td><EventStatus title={item.event_title} subtitle={item.event_subtitle} /></td>
      <td className="text-end">{item.temperature && item.temperature}</td>
      <td className="text-end"><EventBattery battery={item.battery} voltage={item.battery_full} /></td>
      <td className="text-end"><EventSignal signal={item.signal} rssi={item.signal_raw} /></td>
      <td className="position-relative"><ActionButton item={item} onActionClick={onActionClick} /></td>
    </tr>
  )
}

const ActionButton = ({ item, onActionClick }) => {
  if (!onActionClick) return null;
  const isDeletable = EVENTS_DELETABLE[item.event_name];
  if (!['tilt_alarm', 'trap_activated', 'movement_detected'].includes(item.event_name) && !isDeletable) { return null }

  let variant = 'danger';
  let title = __('Delete Event');

  if (['tilt_alarm', 'trap_activated', 'movement_detected', 'bait_changed', 'other'].includes(item.event_name)) {
    variant = 'primary';
    title = ['tilt_alarm', 'trap_activated', 'movement_detected'].includes(item.event_name) && !(item.animal || item.animal_other) ? __('Register new Catch') : __('Edit');
  }
  return <Button className={classes.actionButton} variant={variant} onClick={() => onActionClick(item)}>{title}</Button>
}
